import * as React from 'react'
import './index.css'
import Header from '../Header'
import SideNavbar from '../../../../components/SideNavbar'
import ManagerNavbar from '../../../../components/SideNavbar/managerNav'
import { useAppSelector } from '../../../../redux/hook'
import EmpNavbar from '../../../../components/SideNavbar/EmpNav'

type LayoutProps = {
    children: React.ReactNode
    custom?: boolean
}

const Layout = ({ children, custom }: LayoutProps) => {
    const [toggle, setToggleNavbar] = React.useState(false)

    const getToggle = (value: boolean) => {
        setToggleNavbar(value)
    }
    const { role } = useAppSelector((state) => state.persistedReducers.user)

    return (
        <>
            <div>
                <div className={`container-fluid ${toggle ? 'collap' : ''}`}>
                    <div className="row">
                        {role &&
                        (role === 'Admin' || role === 'Executive Director') ? (
                            <SideNavbar />
                        ) : role === 'Teacher' ? (
                            <EmpNavbar />
                        ) : (
                            <ManagerNavbar />
                        )}
                        <main
                            className="col-md-9 mt-3
                        ms-sm-auto
                         col-lg-10 
                         px-md-4 main-content-side"
                        >
                            <Header toggle={getToggle} />
                            <div
                                className={
                                    custom
                                        ? 'content mg-top hgt'
                                        : 'content mg-top'
                                }
                            >
                                {children}
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Layout
